var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _g4, _path19, _path20, _path21, _g5, _g6, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g7, _g8, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL2Cases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 160,
    viewBox: "0 0 220 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0277 100.583L86.2765 100.811V64.9648H106.305C107.049 77.5739 102.591 87.4716 90.0277 100.583Z",
    fill: "#F6903F",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.188 85.2344L75.5595 91.3398C66.1722 93.0463 59.339 101.266 59.339 110.86V134.021C59.339 135.064 60.1873 135.917 61.224 135.917H159.037V110.86C159.037 101.266 152.204 93.0463 142.816 91.3398L109.188 85.2344Z",
    fill: "#E84996",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.112 115.289V134.838",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 85,
    width: 101,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.188 85.2344L75.5595 91.3398C66.1722 93.0463 59.339 101.266 59.339 110.86V134.021C59.339 135.064 60.1873 135.917 61.224 135.917H159.037V110.86C159.037 101.266 152.204 93.0463 142.816 91.3398L109.188 85.2344Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7739 113.318C65.7739 103.724 72.6071 95.5044 81.9944 93.798L115.623 87.6925L149.251 93.798C150.222 93.9781 151.165 94.2341 152.079 94.5469C149.525 92.4043 146.424 90.8874 142.965 90.2617L109.336 84.1562L75.7079 90.2617C66.3206 91.9682 59.4875 100.188 59.4875 109.782V132.943C59.4875 133.986 60.3357 134.839 61.3725 134.839H65.7739V113.309V113.318Z",
    fill: "#DA2577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.169 90.0519C123.169 97.2665 116.91 103.107 109.191 103.107C101.472 103.107 95.214 97.2571 95.214 90.0519C95.214 82.8467 101.472 80.4102 109.191 80.4102C116.91 80.4102 123.169 82.8372 123.169 90.0519Z",
    fill: "#E0ADA6",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.188 85.2344L75.5595 91.3398C66.1722 93.0463 59.339 101.266 59.339 110.86V134.021C59.339 135.064 60.1873 135.917 61.224 135.917H159.037V110.86C159.037 101.266 152.204 93.0463 142.816 91.3398L109.188 85.2344Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7296 115.289V134.838",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.916 49.5881C136.916 35.1588 125.248 23.4219 110.903 23.4219H108.047C93.7025 23.4219 82.0343 35.1588 82.0343 49.5881V55.8737H136.916V49.5881Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.901 28.3125H108.036C96.355 28.3125 86.8859 37.8373 86.8859 49.5868V66.4147C86.8859 78.1642 96.355 87.6891 108.036 87.6891H110.901C122.582 87.6891 132.051 78.1642 132.051 66.4147V49.5868C132.051 37.8373 122.582 28.3125 110.901 28.3125Z",
    fill: "#E0ADA6",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.973 28.7031C122.655 32.2773 127.198 39.3498 127.198 47.4935V64.312C127.198 76.0584 117.726 85.5863 106.048 85.5863H103.192C101.656 85.5863 100.158 85.4157 98.7062 85.1028C101.666 86.686 105.04 87.5867 108.631 87.5867H111.487C123.164 87.5867 132.636 78.0588 132.636 66.3124V49.4939C132.636 39.2929 125.492 30.7699 115.973 28.7031Z",
    fill: "#DB9C94"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.908 71.4141V75.4622C133.908 77.1213 132.569 78.4771 130.91 78.4771H112.456",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 28,
    width: 47,
    height: 60
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.901 28.3125H108.036C96.355 28.3125 86.8859 37.8373 86.8859 49.5868V66.4147C86.8859 78.1642 96.355 87.6891 108.036 87.6891H110.901C122.582 87.6891 132.051 78.1642 132.051 66.4147V49.5868C132.051 37.8373 122.582 28.3125 110.901 28.3125Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6984 31.5918C65.6984 31.5918 79.195 55.5965 95.8396 55.5965C103.464 55.5965 110.411 53.3212 115.726 49.6048C121.249 54.6864 129.393 57.9097 138.497 57.9097C155.142 57.9097 140.222 26.2163 140.222 26.2163C140.222 26.2163 90.2129 19.4946 65.7078 31.6013L65.6984 31.5918Z",
    fill: "#FCD34D",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.986 43.5469C120.073 46.1919 117.538 48.5242 114.55 50.4108",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.901 28.3125H108.036C96.355 28.3125 86.8859 37.8373 86.8859 49.5868V66.4147C86.8859 78.1642 96.355 87.6891 108.036 87.6891H110.901C122.582 87.6891 132.051 78.1642 132.051 66.4147V49.5868C132.051 37.8373 122.582 28.3125 110.901 28.3125Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.872 75.0352H107.508C105.727 75.0352 104.284 76.4868 104.284 78.2775V78.7989C104.284 80.5896 105.727 82.0413 107.508 82.0413H110.872C112.653 82.0413 114.096 80.5896 114.096 78.7989V78.2775C114.096 76.4868 112.653 75.0352 110.872 75.0352Z",
    fill: "#6167AE",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8769 50.6016H86.5319C87.0503 50.6016 87.4744 51.0282 87.4744 51.5496V70.3874C87.4744 70.9089 87.0503 71.3355 86.5319 71.3355H80.8769C78.8882 71.3355 77.2765 69.7143 77.2765 67.7139V54.2231C77.2765 52.2227 78.8882 50.6016 80.8769 50.6016Z",
    fill: "#6167AE",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.418 71.3359H132.763C132.245 71.3359 131.821 70.9093 131.821 70.3879V51.5501C131.821 51.0286 132.245 50.602 132.763 50.602H138.418C140.407 50.602 142.019 52.2232 142.019 54.2236V67.7144C142.019 69.7148 140.407 71.3359 138.418 71.3359Z",
    fill: "#6167AE",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M164.69 92.6953H103.117C101.035 92.6953 99.3468 94.3931 99.3468 96.4875V137.785C99.3468 139.879 101.035 141.577 103.117 141.577H164.69C166.773 141.577 168.461 139.879 168.461 137.785V96.4875C168.461 94.3931 166.773 92.6953 164.69 92.6953Z",
    fill: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 92,
    width: 70,
    height: 50
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.69 92.6953H103.117C101.035 92.6953 99.3468 94.3931 99.3468 96.4875V137.785C99.3468 139.879 101.035 141.577 103.117 141.577H164.69C166.773 141.577 168.461 139.879 168.461 137.785V96.4875C168.461 94.3931 166.773 92.6953 164.69 92.6953Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_311)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.7 92.697H164.54V135.777C164.54 136.819 163.691 137.673 162.655 137.673H99.3468V137.777C99.3468 139.872 101.034 141.569 103.117 141.569H164.69C166.773 141.569 168.461 139.872 168.461 137.777V96.4797C168.461 94.3845 166.773 92.6875 164.69 92.6875L164.7 92.697Z",
    fill: "#64748B"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M164.69 92.6953H103.117C101.035 92.6953 99.3468 94.3931 99.3468 96.4875V137.785C99.3468 139.879 101.035 141.577 103.117 141.577H164.69C166.773 141.577 168.461 139.879 168.461 137.785V96.4875C168.461 94.3931 166.773 92.6953 164.69 92.6953Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.378 97.5977H161.979",
    stroke: "#F1F5F9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.073 97.5977H154.875",
    stroke: "#F1F5F9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.331 122.188C135.106 122.188 137.355 119.926 137.355 117.135C137.355 114.344 135.106 112.082 132.331 112.082C129.557 112.082 127.308 114.344 127.308 117.135C127.308 119.926 129.557 122.188 132.331 122.188Z",
    fill: "#F1F5F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 39.207H158.062C154.414 39.207 151.464 42.1839 151.464 45.8434V63.8469C151.464 67.5159 154.423 70.4833 158.062 70.4833H164.621L164.659 82.7321L175.14 70.4833H195.517C199.164 70.4833 202.114 67.5064 202.114 63.8469V45.8434C202.114 42.1744 199.155 39.207 195.517 39.207Z",
    fill: "#4BBAEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 39,
    width: 52,
    height: 44
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 39,
    width: 52,
    height: 44
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 39.207H158.062C154.414 39.207 151.464 42.1839 151.464 45.8434V63.8469C151.464 67.5159 154.423 70.4833 158.062 70.4833H164.621L164.659 82.7321L175.14 70.4833H195.517C199.164 70.4833 202.114 67.5064 202.114 63.8469V45.8434C202.114 42.1744 199.155 39.207 195.517 39.207Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.517 39.207H158.062C154.414 39.207 151.464 42.1839 151.464 45.8434V63.8469C151.464 67.5159 154.423 70.4833 158.062 70.4833H164.621L164.659 82.7321L175.14 70.4833H195.517C199.164 70.4833 202.114 67.5064 202.114 63.8469V45.8434C202.114 42.1744 199.155 39.207 195.517 39.207Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.905 67.4782C154.038 67.4782 153.209 67.2791 152.464 66.9283C153.67 68.284 155.423 69.1468 157.384 69.1468L165.989 71.2514V68.54C165.989 67.9522 165.508 67.4687 164.924 67.4687H154.905V67.4782ZM198.534 39.5391C198.892 40.2975 199.09 41.1413 199.09 42.0324V62.9844C199.09 65.4683 197.082 67.4877 194.613 67.4877H174.123C173.765 67.4877 173.425 67.6394 173.199 67.9143L164.754 77.7835V81.4051L175.244 69.1562H195.621C199.269 69.1562 202.219 66.1794 202.219 62.5199V44.5163C202.219 42.5349 199.9 40.7621 198.524 39.5485L198.534 39.5391Z",
    fill: "#2DA2DB"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 39.207H158.062C154.414 39.207 151.464 42.1839 151.464 45.8434V63.8469C151.464 67.5159 154.423 70.4833 158.062 70.4833H164.621L164.659 82.7321L175.14 70.4833H195.517C199.164 70.4833 202.114 67.5064 202.114 63.8469V45.8434C202.114 42.1744 199.155 39.207 195.517 39.207Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.409 46.6289H195.526",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.073 46.6289H185.217",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.714 54.6406H195.53",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.073 54.6406H176.528",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M181.526 62.6523H183.619",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M158.073 62.6523H177.008",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9384 56.707H24.4834C20.8359 56.707 17.8859 59.6839 17.8859 63.3434V81.3469C17.8859 85.0159 20.8454 87.9833 24.4834 87.9833H44.8603L55.3409 100.232L55.3786 87.9833H61.9384C65.5859 87.9833 68.536 85.0064 68.536 81.3469V63.3434C68.536 59.6744 65.5765 56.707 61.9384 56.707Z",
    fill: "#FBDF47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 56,
    width: 52,
    height: 45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 56,
    width: 52,
    height: 45
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9384 56.707H24.4834C20.8359 56.707 17.8859 59.6839 17.8859 63.3434V81.3469C17.8859 85.0159 20.8454 87.9833 24.4834 87.9833H44.8603L55.3409 100.232L55.3786 87.9833H61.9384C65.5859 87.9833 68.536 85.0064 68.536 81.3469V63.3434C68.536 59.6744 65.5765 56.707 61.9384 56.707Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9384 56.707H24.4834C20.8359 56.707 17.8859 59.6839 17.8859 63.3434V81.3469C17.8859 85.0159 20.8454 87.9833 24.4834 87.9833H44.8603L55.3409 100.232L55.3786 87.9833H61.9384C65.5859 87.9833 68.536 85.0064 68.536 81.3469V63.3434C68.536 59.6744 65.5765 56.707 61.9384 56.707Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1298 85.0803C20.2815 85.0803 19.4804 84.9191 18.7453 84.6252C19.8763 86.6351 22.0252 87.9908 24.4851 87.9908H44.0043L41.5067 85.0803H21.1298ZM64.3247 57.1602C64.8713 58.1272 65.1824 59.2364 65.1824 60.4309V78.4345C65.1824 82.1034 62.2229 85.0708 58.5848 85.0708H52.025L51.9968 96.3147L55.3426 100.23L55.3803 87.9814H61.9402C65.5876 87.9814 68.5377 85.0045 68.5377 81.345V63.3415C68.5377 60.5257 66.7846 58.1177 64.3247 57.1602Z",
    fill: "#F8CB17"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9385 56.707H24.4834C20.8359 56.707 17.8859 59.6839 17.8859 63.3434V81.3469C17.8859 85.0159 20.8454 87.9833 24.4834 87.9833H44.8603L55.3409 100.232L55.3786 87.9833H61.9385C65.5859 87.9833 68.536 85.0064 68.536 81.3469V63.3434C68.536 59.6744 65.5765 56.707 61.9385 56.707Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8156 63.6289H61.9324",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5187 63.6289H51.6308",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 63.6289H36.5814",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8078 71.6484H61.9312",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 71.6484H48.127",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7453 79.6602H57.0318",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 79.6602H45.3089",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Cases);
export default __webpack_public_path__ + "static/media/L2_Cases.d2b443ce7b587bed27c520d3fbd83818.svg";
export { ForwardRef as ReactComponent };